import { Injectable } from '@angular/core';
import { CoreHttpService } from '../../utilities/services/http.service';
import { Constants } from '../../models/constants';
import { Observable, EMPTY, of } from 'rxjs';
import { CoreSessionService } from '../../providers/services/session.service';
import { CoreUtilityService } from '../../utilities/services/utility.service';

@Injectable({
  providedIn: 'root'
})
export class CoreBaseFormService {
  constructor(
    private coreHttpServiceHandler: CoreHttpService,
    private coreSessionService: CoreSessionService,
    private coreUtilityService: CoreUtilityService
  ) {}

  /**
   * Get application schema from server
   */
  getApplicationSchema(): Observable<any> {
    return this.coreHttpServiceHandler.doGet(Constants.api.postLoginSchema);
    // return this.coreHttpServiceHandler.doGet(Constants.schema.postLogin);
  }

  /**
   * Get Module schema from session storage
   * @param moduleName - module name
   */
  getModuleSchema(moduleName: string): Observable<any> {
    const allModulesSchema: Array<any> = this.coreSessionService.getAllModulesSchema() || [];
    const currentModuleSchema = allModulesSchema.find((mod) => this.coreUtilityService.strictCompare(mod.logicalName, moduleName));
    return currentModuleSchema ? of(currentModuleSchema) : EMPTY;
  }

  /**
   * Get schema for On boarding page
   * @param moduleName - module name
   */
  getOnBoardingPageSchema(moduleName: string): Observable<any> {
    return this.coreHttpServiceHandler.doGet(Constants.schema[moduleName]);
  }

  /**
   * Save module form data to the server
   * @param url - api url
   * @param data - data for saving
   */
  saveModuleForm(url: string, data: object): Observable<any> {
    // moduleName: string
    return this.coreHttpServiceHandler.doPost(url, data); // Constants.api[moduleName]
  }

  // login(data: object) {
  //   return this.coreHttpService.doPost(Constants.api.login, data).toPromise().then(resp => resp);
  //   // return this.coreHttpService.doPost(Constants.api.registration, data).toPromise().then(resp => resp);
  // }

  // TODO: Do not use this. Instead call directly.
  /**
   * This method will call the http services
   * @param endPoint - urls
   * @param type - get/post type
   * @param params - api params
   */
  coreHttpService(endPoint: string, type: string, params?: object) {
    let httpResp;
    if (params) {
      httpResp = this.coreHttpServiceHandler
        .doCheck(endPoint, type, params)
        .toPromise()
        .then((resp) => resp);
    } else {
      httpResp = this.coreHttpServiceHandler
        .doCheck(endPoint, type)
        .toPromise()
        .then((resp) => resp);
    }
    return httpResp;
  }

  /**
   * this method will check the current module with status
   * @param currentModule - current module name
   */
  checkCurrentModuleWithStatus(currentModule): boolean {
    if (this.coreSessionService.applicationStatus && currentModule) {
      return !this.coreUtilityService.strictCompare(this.coreSessionService.applicationStatus.toLowerCase(), currentModule.toLowerCase());
    } else {
      return false;
    }
  }
}
